export default function startsByVowel(string) {
  return /^[aeiouàâäéèêëîïôöùûü]/i.test(string);
}
